import { type SVGProps } from "react";

export function ImageGalleryPlaceholderIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="206"
      height="206"
      viewBox="0 0 206 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.6466 167.375C39.9047 167.375 27.6821 158.577 23.2445 145.479L22.9441 144.492C21.8969 141.024 21.4591 138.106 21.4591 135.187V76.666L0.635974 146.174C-2.04203 156.397 4.06072 166.997 14.3006 169.821L147.025 205.365C148.681 205.794 150.338 206 151.969 206C160.518 206 168.329 200.326 170.517 191.966L178.251 167.375H53.6466Z"
        fill="currentColor"
      />
      <path
        d="M77.2507 77.2498C86.7181 77.2498 94.4173 69.5506 94.4173 60.0832C94.4173 50.6158 86.7181 42.9165 77.2507 42.9165C67.7832 42.9165 60.084 50.6158 60.084 60.0832C60.084 69.5506 67.7832 77.2498 77.2507 77.2498Z"
        fill="currentColor"
      />
      <path
        d="M184.54 17.1665H55.7904C43.9625 17.1665 34.332 26.797 34.332 38.6248V133.042C34.332 144.869 43.9625 154.5 55.7904 154.5H184.54C196.368 154.5 205.999 144.869 205.999 133.042V38.6248C205.999 26.797 196.368 17.1665 184.54 17.1665ZM55.7904 34.3332H184.54C186.909 34.3332 188.832 36.2558 188.832 38.6248V99.5579L161.717 67.9198C158.842 64.5465 154.679 62.744 150.207 62.641C145.761 62.6668 141.589 64.6409 138.74 68.0571L106.861 106.322L96.4754 95.9615C90.6044 90.0905 81.0511 90.0905 75.1887 95.9615L51.4987 119.643V38.6248C51.4987 36.2558 53.4214 34.3332 55.7904 34.3332Z"
        fill="currentColor"
      />
    </svg>
  );
}
